import { useEffect, useState } from 'react'

type UseAvoidLayoutShiftResponse = {
  isSkeletonVisible: boolean
}

type UseAvoidLayoutShiftParams = {
  duration?: number
  callbackBeforeRender?: () => void
}

const useAvoidLayoutShift = ({
  duration = 500,
  callbackBeforeRender,
}: UseAvoidLayoutShiftParams = {}): UseAvoidLayoutShiftResponse => {
  const [isSkeletonVisible, setIsSkeletonVisible] = useState(true)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      callbackBeforeRender?.()
      setIsSkeletonVisible(false)
    }, duration)

    // cleanup function to avoid memory leaks
    return () => clearTimeout(timeoutId)
  }, [duration, callbackBeforeRender])

  return { isSkeletonVisible }
}

export default useAvoidLayoutShift
